var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex justify-center items-center h-[80vh]"
};
const _hoisted_2 = { key: 1 };
import { useNotificationEvent } from '@/composable/Notification';
import { appState } from '@/composable/appState';
import config from '@/config';
import { CHAT_ICONS, ChatBubbleOptions, ChatType, ContactFormOptions, DefaultTheme, DefaultThemes, FallBackTimeOptions, LocaleOptions, SuccessAcknowledgementBGColor, ThemeName, WhatsappTheme, WidgetPositionOptions, acknowledgementIconsLiveChatOptions, acknowledgementIconsOptions, } from '@/helper/const';
import { generateRandomNumber, levelItemCheck, toCamelCase, } from '@/helper/helper';
import { i18n } from '@/plugin/vue-i18n';
import { ChatWidgetServices } from '@/service/ChatWidgetService';
import { CustomFieldsServices } from '@/service/CustomFieldsService';
import { WhatsappServices } from '@/service/WhatsappService';
import { UISpin } from '@gohighlevel/ghl-ui';
import { cloneDeep, debounce } from 'lodash';
import { inject, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import BuilderHeader from './BuilderHeader.vue';
import BuilderSidebar from './BuilderSidebar.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BuilderContainer',
    setup(__props) {
        const { sendNotification, handleError } = useNotificationEvent();
        const route = inject('route');
        const tokenId = inject('tokenId');
        const user = inject('user');
        const companyInfo = inject('companyInfo');
        const locationInfo = inject('locationInfo');
        const locale = inject('locale');
        const loading = ref(false);
        const saving = ref(false);
        const router = inject('router');
        const settingDefault = ref(false);
        const i18nInstance = useI18n();
        const DEPLOYMENT_BASE_URL = config.DEPLOYMENT_URL;
        const DEFAULT_AVATAR_IMAGE = ref(`${DEPLOYMENT_BASE_URL}chat-widget/assets/defaultAvatar.png`);
        const defaultSettings = {
            liveChatIntroMsg: 'Give us a minute to assign you the best person to help you out.',
            liveChatUserInactiveMsg: 'Looks like no one is available. Please leave your contact details. We will get back to you shortly.',
            liveChatVisitorInactiveMsg: 'Chat closed due to user Inactivity',
            subHeading: 'Enter your question below and a representative will get right back to you.',
            heading: 'Have a question?',
            successMsg: 'One of our representatives will contact you shortly.',
            liveChatAckMsg: 'Your chat has ended',
            liveChatFeedbackNote: 'Thank you, for taking your time.',
            thankYouMsg: 'Thank You!',
            liveChatFeedbackMsg: 'Please rate your experience.',
            liveChatEndedMsg: 'To start a new chat,',
            promptMsg: 'Hi there, have a question? Text us here.',
            revisitPromptMsg: 'Welcome back {{name}}, how can we help you today?',
            legalMsg: 'By submitting you agree to receive SMS or e-mails for the provided channel. Rates may be applied.',
            showPrompt: true,
            allowAvatarImage: true,
            promptAvatarAltText: 'Avatar',
            promptType: ChatBubbleOptions[0].value,
            locale: LocaleOptions[2].value,
            promptAvatar: DEFAULT_AVATAR_IMAGE.value,
            enableRevisitMessage: true,
            liveChatUserInactiveTime: FallBackTimeOptions[1].value,
            liveChatVisitorInactiveTime: FallBackTimeOptions[1].value,
            showAgencyBranding: true,
            showLiveChatWelcomeMsg: true,
            agencyName: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name) || '',
            agencyWebsite: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.website) || '',
            showConsentCheckbox: true,
            isPromptAvatarImageOptimize: true,
        };
        const initializeAppState = route => {
            appState.chatWidgetId = route.params.widgetId;
            appState.locationId = route.params.location_id;
            appState.tokenId = tokenId;
            appState.userId = user.id;
        };
        const setDefaultSettings = (settings) => {
            for (const prop in defaultSettings) {
                if (!settings.hasOwnProperty(prop) || settings[prop] === null) {
                    settings[prop] = defaultSettings[prop];
                    if (settings.chatType === ChatType.LIVE_CHAT &&
                        settings.useEmailField === undefined) {
                        settings.useEmailField = false;
                    }
                }
            }
        };
        const setSendActionText = (settings) => {
            if (settings.sendActionText === undefined) {
                settings.sendActionText =
                    settings.chatType === ChatType.WA_CHAT ? 'Chat with us' : 'Send';
            }
        };
        const setDimensions = (settings) => {
            if (settings.dimensions === undefined) {
                settings.dimensions = {
                    sizes: { height: '', width: '' },
                    position: WidgetPositionOptions[0].value,
                };
            }
        };
        const setAcknowledgementDetails = (settings) => {
            if (settings.acknowledgementDetails === undefined) {
                settings.acknowledgementDetails = {
                    icon: settings.chatType === ChatType.LIVE_CHAT
                        ? acknowledgementIconsLiveChatOptions[0].value
                        : acknowledgementIconsOptions[0].value,
                    placeholderColor: SuccessAcknowledgementBGColor,
                };
            }
        };
        const chatIcon = (settings) => {
            if (!settings.chatIcon) {
                settings.chatIcon =
                    settings.chatType === ChatType.WA_CHAT
                        ? CHAT_ICONS.MESSAGE_WHATSAPP
                        : CHAT_ICONS.MESSAGE_CHAT_CIRCLE;
            }
        };
        const setTheme = (settings) => {
            if (!!settings.widgetPrimaryColor && !settings.theme) {
                settings.theme = {
                    name: ThemeName.CUSTOM,
                    colors: {
                        chatBubbleColor: settings.widgetPrimaryColor,
                        backgroundColor: DefaultTheme[ThemeName.BLUE].colors.backgroundColor,
                        headerColor: settings.widgetPrimaryColor,
                        buttonColor: settings.widgetPrimaryColor,
                        avatarBackgroundColor: DefaultTheme[ThemeName.BLUE].colors.avatarBackgroundColor,
                        avatarBorderColor: settings.widgetPrimaryColor,
                        senderMessageColor: settings.widgetPrimaryColor,
                        receivedMessageColor: DefaultTheme[ThemeName.BLUE].colors.receivedMessageColor,
                    },
                    typography: Object.assign({}, DefaultTheme[ThemeName.BLUE].typography),
                };
            }
            else if (!settings.theme) {
                settings.theme = cloneDeep(ChatType.WA_CHAT === settings.chatType
                    ? WhatsappTheme[ThemeName.CUSTOM]
                    : DefaultThemes[ThemeName.BLUE]);
                appState.unsavedChanges = true;
            }
            else if ((settings.theme.name === ThemeName.CUSTOM &&
                !settings.theme.typography.colors.welcomeMessageTextColor) ||
                !settings.theme.typography.colors.headerMessageTextColor) {
                settings.theme.typography.colors.headerMessageTextColor =
                    settings.theme.typography.colors.headerMessageTextColor ||
                        settings.theme.typography.colors.senderMessageTextColor ||
                        DefaultTheme[ThemeName.BLUE].typography.colors.headerMessageTextColor;
                settings.theme.typography.colors.welcomeMessageTextColor =
                    settings.theme.typography.colors.welcomeMessageTextColor ||
                        settings.theme.typography.colors.systemMessageTextColor ||
                        DefaultTheme[ThemeName.BLUE].typography.colors.welcomeMessageTextColor;
            }
        };
        const setAdvanceSettings = (settings) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            const defaultOptions = [
                {
                    id: '1',
                    value: 'name',
                    label: 'Name',
                    disabled: true,
                    dataType: 'TEXT',
                    fieldKey: 'contact.name',
                    placeholder: 'Name',
                },
                {
                    id: '2',
                    value: 'phone',
                    label: 'Phone',
                    dataType: 'PHONE',
                    fieldKey: 'contact.phone',
                    placeholder: 'Phone',
                },
            ];
            const emailOption = {
                id: '3',
                value: 'email',
                label: 'Email',
                dataType: 'EMAIL',
                fieldKey: 'contact.email',
                placeholder: 'Email',
            };
            const messageOption = {
                id: '4',
                value: 'message',
                label: 'Message',
                dataType: 'TEXTAREA',
                fieldKey: 'contact.message',
                placeholder: 'Message',
            };
            const getContactFormOptions = () => {
                if ((settings === null || settings === void 0 ? void 0 : settings.chatType) !== ChatType.LIVE_CHAT && appState.levelUpCompany) {
                    let options = settings.useEmailField
                        ? [...defaultOptions, emailOption]
                        : defaultOptions;
                    options = [...options, messageOption];
                    return options;
                }
            };
            settings.advanceSettings = Object.assign({ brandingTitle: ((_a = settings === null || settings === void 0 ? void 0 : settings.advanceSettings) === null || _a === void 0 ? void 0 : _a.brandingTitle) || 'Powered by', defaultConsentCheck: ((_b = settings === null || settings === void 0 ? void 0 : settings.advanceSettings) === null || _b === void 0 ? void 0 : _b.defaultConsentCheck) || true }, settings.advanceSettings);
            if (settings.chatType !== ChatType.WA_CHAT) {
                settings.advanceSettings.redirect = Object.assign({ redirectAction: ((_d = (_c = settings === null || settings === void 0 ? void 0 : settings.advanceSettings) === null || _c === void 0 ? void 0 : _c.redirect) === null || _d === void 0 ? void 0 : _d.redirectAction) || false, redirectText: ((_f = (_e = settings === null || settings === void 0 ? void 0 : settings.advanceSettings) === null || _e === void 0 ? void 0 : _e.redirect) === null || _f === void 0 ? void 0 : _f.redirectText) ||
                        'For more details, please visit our website' }, (_g = settings.advanceSettings) === null || _g === void 0 ? void 0 : _g.redirect);
            }
            if (settings.chatType !== ChatType.LIVE_CHAT && appState.levelUpCompany) {
                if (!settings.advanceSettings.contactFormOptions ||
                    settings.advanceSettings.contactFormOptions.length === 0) {
                    settings.advanceSettings.contactFormOptions = getContactFormOptions();
                }
                if (settings.advanceSettings.contactFormOptions.length > 0) {
                    appState.chatWidgetSettingsData.advanceSettings.contactFormOptions =
                        settings.advanceSettings.contactFormOptions;
                    appState.chatWidgetSettingsData.advanceSettings.contactFormOptions.forEach(option => {
                        let matchingField = appState.customFields.find(field => field.id === option.id);
                        if (!matchingField) {
                            appState.customFields.forEach(field => {
                                if (field.children) {
                                    const childMatch = field.children.find(child => child.id === option.id);
                                    if (childMatch) {
                                        matchingField = childMatch;
                                    }
                                }
                            });
                        }
                        if (matchingField) {
                            option.value = matchingField.value;
                        }
                    });
                }
            }
            if (settings.chatType === ChatType.LIVE_CHAT && appState.levelUpCompany) {
                settings.advanceSettings.businessOfficeHours = {
                    enableBusinessHours: ((_j = (_h = settings === null || settings === void 0 ? void 0 : settings.advanceSettings) === null || _h === void 0 ? void 0 : _h.businessOfficeHours) === null || _j === void 0 ? void 0 : _j.enableBusinessHours) ||
                        false,
                    openHours: ((_l = (_k = settings === null || settings === void 0 ? void 0 : settings.advanceSettings) === null || _k === void 0 ? void 0 : _k.businessOfficeHours) === null || _l === void 0 ? void 0 : _l.openHours) || [],
                    timezone: ((_o = (_m = settings === null || settings === void 0 ? void 0 : settings.advanceSettings) === null || _m === void 0 ? void 0 : _m.businessOfficeHours) === null || _o === void 0 ? void 0 : _o.timezone) ||
                        (appState === null || appState === void 0 ? void 0 : appState.timeZone),
                    outsideOfficeHoursWelcomeMsg: ((_q = (_p = settings === null || settings === void 0 ? void 0 : settings.advanceSettings) === null || _p === void 0 ? void 0 : _p.businessOfficeHours) === null || _q === void 0 ? void 0 : _q.outsideOfficeHoursWelcomeMsg) || 'We are currently offline.',
                };
            }
        };
        const fetchChatWidgetData = () => __awaiter(this, void 0, void 0, function* () {
            const { data: chatWidgetData } = yield ChatWidgetServices.getChatWidget(appState.locationId, appState.chatWidgetId);
            appState.chatWidgetName = chatWidgetData.name;
            appState.updatedAt = chatWidgetData.updatedAt;
            appState.chatWidgetSettingsData = chatWidgetData.settings;
        });
        const fetchCustomFields = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { data: customFieldsData } = yield CustomFieldsServices.getContactCustomFields(appState.locationId);
            const filteredFields = (_a = customFieldsData === null || customFieldsData === void 0 ? void 0 : customFieldsData.customFields) === null || _a === void 0 ? void 0 : _a.filter(field => {
                var _a;
                return (_a = [
                    'TEXT',
                    'MONETORY',
                    'PHONE',
                    'NUMERICAL',
                    'LARGE_TEXT',
                    'DATE',
                    'SINGLE_OPTIONS',
                ]) === null || _a === void 0 ? void 0 : _a.includes(field === null || field === void 0 ? void 0 : field.dataType);
            });
            const normalizeFields = (fields) => {
                return fields.map((field) => ({
                    value: generateRandomNumber() + toCamelCase(field === null || field === void 0 ? void 0 : field.name),
                    label: field === null || field === void 0 ? void 0 : field.name,
                    dataType: field === null || field === void 0 ? void 0 : field.dataType,
                    placeholder: field === null || field === void 0 ? void 0 : field.placeholder,
                    fieldKey: field === null || field === void 0 ? void 0 : field.fieldKey,
                    picklistOptions: field === null || field === void 0 ? void 0 : field.picklistOptions,
                    id: field === null || field === void 0 ? void 0 : field.id,
                }));
            };
            const normalizedCustomFields = normalizeFields(filteredFields || []).sort((a, b) => a.label.localeCompare(b.label));
            appState.customFields = [
                ...ContactFormOptions,
                {
                    type: 'group',
                    label: 'Custom Fields',
                    value: 'custom-fields',
                    children: [...normalizedCustomFields],
                },
            ];
        });
        const initializeSettings = () => {
            if (appState.chatWidgetSettingsData) {
                setDefaultSettings(appState.chatWidgetSettingsData);
                setSendActionText(appState.chatWidgetSettingsData);
                setDimensions(appState.chatWidgetSettingsData);
                setAcknowledgementDetails(appState.chatWidgetSettingsData);
                setTheme(appState.chatWidgetSettingsData);
                setAdvanceSettings(appState.chatWidgetSettingsData);
            }
        };
        const checkWhatsappNumber = () => __awaiter(this, void 0, void 0, function* () {
            var _b, _c;
            try {
                const whatsappNumber = yield WhatsappServices.getWhatsAppPhoneNumbersForLocationId(appState.locationId);
                const whatsappSubscription = yield WhatsappServices.getLocationSubscriptions(appState.locationId);
                const WANumbersData = (_b = whatsappNumber === null || whatsappNumber === void 0 ? void 0 : whatsappNumber.data) === null || _b === void 0 ? void 0 : _b.filter(el => (el === null || el === void 0 ? void 0 : el.status) == 'CONNECTED');
                const isSubscribed = whatsappSubscription === null || whatsappSubscription === void 0 ? void 0 : whatsappSubscription.data;
                if (WANumbersData.length > 0 && isSubscribed) {
                    const WANumbersMap = WANumbersData.map(item => {
                        return {
                            label: item === null || item === void 0 ? void 0 : item.verifiedName,
                            value: item === null || item === void 0 ? void 0 : item.displayPhoneNumber.replace(/\D/g, ''),
                        };
                    });
                    appState.waNumbers = WANumbersMap;
                    if (!appState.chatWidgetSettingsData.waNumber) {
                        appState.chatWidgetSettingsData.waNumber = (_c = appState.waNumbers[0]) === null || _c === void 0 ? void 0 : _c.value;
                        appState.unsavedChanges = true;
                    }
                }
            }
            catch (err) {
                console.error(err);
            }
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            try {
                initializeAppState(route);
                loading.value = true;
                yield fetchChatWidgetData();
                if (levelItemCheck(companyInfo.companyId))
                    yield fetchCustomFields();
                initializeSettings();
                const { data } = yield ChatWidgetServices.getChatWidget(appState.locationId, appState.chatWidgetId);
                loading.value = false;
                appState.chatWidgetName = data.name;
                appState.updatedAt = data.updatedAt;
                appState.chatWidgetSettingsData = data.settings;
                appState.locale = locale;
                i18nInstance.locale.value = appState.locale;
                appState.levelUpCompany = levelItemCheck(companyInfo.companyId);
                if (appState.levelUpCompany) {
                    appState.timeZone = locationInfo.timezone || 'America/Los_Angeles';
                    appState.locationCountryCode = locationInfo.country;
                }
                if (appState.chatWidgetSettingsData) {
                    setDefaultSettings(appState.chatWidgetSettingsData);
                    setSendActionText(appState.chatWidgetSettingsData);
                    setDimensions(appState.chatWidgetSettingsData);
                    setAcknowledgementDetails(appState.chatWidgetSettingsData);
                    chatIcon(appState.chatWidgetSettingsData);
                    setTheme(appState.chatWidgetSettingsData);
                    setAdvanceSettings(appState.chatWidgetSettingsData);
                    checkWhatsappNumber();
                }
            }
            catch (error) {
                router.push({ name: 'chat-widget' });
            }
            finally {
                loading.value = false;
            }
        }));
        const handleUpdateChatWidget = () => __awaiter(this, void 0, void 0, function* () {
            var _d, _e;
            try {
                saving.value = true;
                if (appState.chatWidgetSettingsData.chatType === ChatType.LIVE_CHAT &&
                    ((_d = appState.chatWidgetSettingsData.advanceSettings) === null || _d === void 0 ? void 0 : _d.businessOfficeHours) &&
                    appState.levelUpCompany) {
                    appState.chatWidgetSettingsData.advanceSettings.businessOfficeHours.timezone =
                        appState.timeZone;
                }
                if (appState.chatWidgetSettingsData.chatType !== ChatType.LIVE_CHAT &&
                    ((_e = appState.chatWidgetSettingsData.advanceSettings) === null || _e === void 0 ? void 0 : _e.contactFormOptions) &&
                    appState.levelUpCompany) {
                    appState.chatWidgetSettingsData.locationCountryCode =
                        appState.locationCountryCode || 'US';
                }
                const data = yield ChatWidgetServices.updateChatWidget(appState.locationId, appState.chatWidgetId, {
                    settings: Object.assign({}, appState.chatWidgetSettingsData),
                });
                saving.value = false;
                sendNotification({
                    type: 'success',
                    title: i18n.global.t('builder.chatWidgetSavedSuccessfully'),
                });
                appState.unsavedChanges = false;
                appState.updatedAt = data.data.updatedAt;
            }
            catch (error) {
                handleError(error);
                saving.value = false;
            }
        });
        const handleUpdateTitle = debounce((val) => __awaiter(this, void 0, void 0, function* () {
            try {
                saving.value = true;
                appState.chatWidgetName = val;
                const data = yield ChatWidgetServices.updateChatWidget(appState.locationId, appState.chatWidgetId, { name: val });
                saving.value = false;
                sendNotification({
                    type: 'success',
                    title: i18n.global.t('builder.chatWidgetNameUpdatedSuccessfully'),
                });
                appState.updatedAt = data.data.updatedAt;
            }
            catch (error) {
                handleError(error);
                saving.value = false;
            }
        }), 1000);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(BuilderHeader, {
                    title: _unref(appState).chatWidgetName,
                    "setting-default": settingDefault.value,
                    "onUpdate:title": _unref(handleUpdateTitle),
                    "onSave:chatWidget": handleUpdateChatWidget,
                    loading: saving.value
                }, null, 8 /* PROPS */, ["title", "setting-default", "onUpdate:title", "loading"]),
                (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_unref(UISpin))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(BuilderSidebar)
                    ]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
